import { lazy } from "react";

export function lazyWithRetry<T extends { default: any }>(
  importFn: () => Promise<T>,
  retries = 3,
  interval = 1000,
) {
  return lazy(() => {
    return new Promise<T>((resolve, reject) => {
      const attempt = (retriesLeft: number) => {
        importFn().then(resolve).catch((error: Error) => {
          if (retriesLeft <= 0) return reject(error);
          setTimeout(() => attempt(retriesLeft - 1), interval * (retries - retriesLeft + 1));
        });
      };
      attempt(retries);
    });
  });
}
